exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading-offset-wrapper[data-v-c9cc5ca0]{position:relative;margin-top:60px}.heading-offset-30[data-v-c9cc5ca0]{position:relative;top:-31px}.heading-offset-40[data-v-c9cc5ca0]{position:relative;top:-42px}", ""]);

// exports
